export class DashboardData {
    constructor(
        public systemId: string,
        public subSystemId?: string,
        public status?: boolean,
        public value?: number,
        public date?: Date
    ){}
}



// WEBPACK FOOTER //
// ./src/app/models/dashboard-data.ts